"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.retry = retry;
const DEFAULT_RETRY_ATTEMPTS = 2;
async function retry(input, options) {
    const retries = options?.retries ?? DEFAULT_RETRY_ATTEMPTS;
    for (let attemptCount = 1; attemptCount <= retries; attemptCount++) {
        try {
            const response = await input(attemptCount);
            if (options?.shouldRetry) {
                const success = await options.shouldRetry(response, attemptCount);
                if (!success && attemptCount < retries) {
                    continue;
                }
            }
            return response;
        }
        catch (error) {
            if (options?.onFailedAttempt) {
                await options.onFailedAttempt(error, attemptCount);
            }
            if (!error || attemptCount >= retries) {
                throw error;
            }
        }
    }
    throw new Error('Exhausted all retries.');
}
//# sourceMappingURL=retry.js.map